import React, { useState } from "react"
import { Link } from "gatsby"
import PlayVideo from "../modules/video_module/PlayVideo";

import ImageModule from "../modules/image_module";
import { PageLinks } from "../common/page-links";

import "./NewsCard.scss";

const NewsCard = (props) => {
    const NewsList = props.NewsList;
    let [isPlay, setPlay] = React.useState(false);
    let [isVideoUrl, setVideoUrl] = React.useState("");
    const videoPlay = (videoUrl) => {
        setPlay(true);
        setVideoUrl(videoUrl)
    }
    const closeVideo = () => {
        setPlay(false)
        setVideoUrl("")
    }

    var detail_url = `/${PageLinks.news_insight}/${NewsList.slug}/`;

    var videoUrl = NewsList?.embed_video_url ? NewsList?.embed_video_url : "";

    const ImageRenderList = ({ item, imagename }) => {
        let processedImages = JSON.stringify({});
        if (item?.imagetransforms?.tile_image_Transforms) {
            processedImages = item?.imagetransforms?.tile_image_Transforms;
        }
        return (
            <ImageModule ImageSrc={item.tile_image} title={item.title} altText={item.title} imagetransforms={processedImages} renderer="srcSet" imagename={imagename} strapi_id={item.id} loading="eager" />
        )
    }

    return (
        <React.Fragment>
            <div className="news-wrapper img-zoom">
                <div className="news-img ">
                    <Link to={detail_url}>
                        <ImageRenderList item={NewsList} imagename={"blog.tile_image.small_image"} />
                    </Link>
                    {
                        videoUrl ?
                            <button className="video-wrap" onClick={() => videoPlay(videoUrl)}><i className="icon-video"></i></button> : ''
                    }
                    {NewsList.tags &&
                        <span className="top-text">{NewsList.tags}</span>
                    }

                </div>
                <div className="news-content">
                    <h3><Link to={detail_url}>{NewsList.title}</Link></h3>
                    <Link to={detail_url} className="blog-btn">
                        View Blog
                    </Link>
                </div>
            </div>

            {isVideoUrl &&
                <PlayVideo
                    isOpen={isPlay}
                    isCloseFunction={closeVideo}
                    videoUrl={isVideoUrl}
                    isAutoPlay={1}
                />
            }
        </React.Fragment>
    );
};
export default NewsCard;
